module.exports = __webpack_public_path__ + "img/favorite-active.fc5a7556.svg";